(function(){
  var picks=[].slice.call(document.querySelectorAll('.n-pick'));
  picks.forEach(function(b){b.addEventListener('click',function(){
    picks.forEach(function(o){o.setAttribute('aria-selected',String(o===b));});
    ['n-panel-video','n-panel-obit','n-panel-page'].forEach(function(id){
      document.getElementById(id).hidden=(id!==b.getAttribute('aria-controls'));
    });
    var mv=document.getElementById('nMsgVideo'),mb=document.getElementById('nMsgSound');
    if(mv){
      if(b.getAttribute('aria-controls')==='n-panel-video'){mv.play().catch(function(){});}
      else{
        mv.pause();mv.muted=true;
        mb.classList.remove('is-on');
        mb.setAttribute('aria-pressed','false');
        mb.setAttribute('aria-label','Play with sound');
      }
    }
  });});
  var sv=document.getElementById('nMsgVideo'),sb=document.getElementById('nMsgSound');
  if(sv&&sb){sb.addEventListener('click',function(){
    sv.muted=!sv.muted;
    if(!sv.muted){sv.currentTime=0;}
    sv.play().catch(function(){});
    sb.setAttribute('aria-pressed',String(!sv.muted));
    sb.setAttribute('aria-label',sv.muted?'Play with sound':'Mute');
    sb.classList.toggle('is-on',!sv.muted);
  });}
})();
(function(){
  // the shell's head script has already decided whether this page moves. Off means finished
  // state everywhere, so the thread through the steps is drawn full rather than at zero.
  var st0=document.querySelector('.step-thread');
  if(!document.documentElement.classList.contains('motion')){
    if(st0)st0.style.height='100%';
    return;
  }
  // an element arrives once: .in is set on first sight and the observer lets it go
  var targets=[].slice.call(document.querySelectorAll('[data-rv],.rv-group>*'));
  var io=new IntersectionObserver(function(es){
    es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('in');io.unobserve(e.target);}});
  },{threshold:.12,rootMargin:'0px 0px -60px 0px'});
  targets.forEach(function(t){io.observe(t);});
  // hero media: settles from a slight scale as it enters
  var hm=document.getElementById('heroMedia');
  function pass(){
    var vh=innerHeight;
    for(var i=0;i<targets.length;i++){
      var t=targets[i],r=t.getBoundingClientRect();
      // an element with no box is not in view: in the single-file artifact the other 25 pages
      // are hidden and measure zero, and marking them now would spend their arrival unseen
      if(!t.classList.contains('in')&&(r.width||r.height)&&r.top<vh*0.92){t.classList.add('in');io.unobserve(t);}
    }
    if(hm){
      var r=hm.getBoundingClientRect();
      var p=Math.max(0,Math.min(1,(vh-r.top)/(vh*0.7)));
      hm.style.transform='scale('+(0.965+0.035*p)+')';
    }
    var st=document.querySelector('.step-thread'),sc=document.querySelector('.steps');
    if(st&&sc){
      var sr=sc.getBoundingClientRect();
      var sp=(vh*0.75-sr.top)/sr.height;
      st.style.height=(Math.max(0,Math.min(1,sp))*sr.height)+'px';
    }
  }
  addEventListener('scroll',pass,{passive:true});
  addEventListener('resize',pass,{passive:true});
  pass(); setTimeout(pass,400); setTimeout(pass,1200);
})();
(function(){
  // nav: dropdowns open on hover (CSS) and toggle on click/keyboard; one open at a time
  var items=[].slice.call(document.querySelectorAll('.has-menu'));
  function closeAll(except){items.forEach(function(li){if(li!==except){li.dataset.open='false';li.querySelector('.nav-btn').setAttribute('aria-expanded','false');}});}
  items.forEach(function(li){
    var b=li.querySelector('.nav-btn');
    b.addEventListener('click',function(e){
      e.stopPropagation();
      var open=li.dataset.open==='true';
      closeAll(li);li.dataset.open=String(!open);b.setAttribute('aria-expanded',String(!open));
    });
  });
  document.addEventListener('click',function(){closeAll();});
  // the mobile menu: a panel under the sticky bar
  var burger=document.querySelector('.burger'),mm=document.getElementById('mobileMenu');
  function toggleMobile(force){
    if(!mm)return;
    var open=typeof force==='boolean'?force:mm.hidden;
    mm.hidden=!open;burger.setAttribute('aria-expanded',String(open));
    document.body.classList.toggle('menu-open',open);
  }
  if(burger&&mm){burger.addEventListener('click',function(){toggleMobile();});}
  document.addEventListener('keydown',function(e){if(e.key==='Escape'){closeAll();toggleMobile(false);}});
  addEventListener('resize',function(){if(innerWidth>=1080&&mm&&!mm.hidden)toggleMobile(false);},{passive:true});
  // quantity steppers
  [].slice.call(document.querySelectorAll('.qty')).forEach(function(q){
    var inp=q.querySelector('input');
    [].slice.call(q.querySelectorAll('button')).forEach(function(b){
      b.addEventListener('click',function(){
        var v=parseInt(inp.value,10)||1;v+=parseInt(b.dataset.d,10);inp.value=Math.max(1,v);
      });
    });
  });
})();
